module.exports = __webpack_public_path__ + "static/media/BG_PDJ_Brain_Power.bb731f71.jpg";